import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M12.6 11.2h.1l3 3a1 1 0 1 1-1.4 1.5l-3-3a1 1 0 0 1-.1-.1 7 7 0 1 1 1.4-1.4M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10"
    }, null, -1)
  ]));
}
const Search = { render };
export {
  Search as default,
  render
};
//# sourceMappingURL=Search.svg.js.map
